export default "__VITE_ASSET__Dsh6_5Dj__"